cm.GamePhases = {
	CHARACTER_SELECT: 0,
	CHALLENGE_SPECIFIC_COSTUME: 1,
	CHALLENGE_COLORPATTERN_COSTUME: 2,
	CHALLENGE_FREEPLAY: 3,
	DANCEOFF: 4
};
